export const getMenuData = [
  {
    title: 'Dashboard',
    key: 'welcomeScreen',
    url: '/dashboard',
    icon: 'fe fe-home',
    iconSvg: 'dashboard',
  },
  {
    category: true,
    title: 'Tools',
  },
  {
    title: 'Analytics',
    key: 'analytics',
    url: '/analytics',
    icon: 'fe fe-bar-chart',
    iconSvg: 'analytics',
    resource: 'analytics',
  },
  {
    title: 'Messages',
    key: 'messaging',
    url: '/messages',
    icon: 'fe fe-mail',
    resource: 'messaging',
  },
  {
    title: 'Aya',
    key: 'aya',
    url: '/aya',
    icon: 'fe fe-message-circle',
    iconSvg: 'aya',
  },
  {
    title: 'Attendance',
    key: 'attendance',
    icon: 'fi fi-rs-clock',
    iconSvg: 'attendance',
    url: '/attendance',
    resource: 'attendance',
  },
  {
    title: 'Calendar',
    key: 'appsCalendar',
    icon: 'fi fi-ss-calendar',
    iconSvg: 'calendar',
    url: '/calendar',
    resource: 'calendar',
  },
  {
    title: 'Forms',
    key: 'forms',
    icon: 'fi fi-rr-document',
    iconSvg: 'forms',
    url: '/forms',
    resource: 'documents',
  },
  {
    title: 'Drive',
    key: 'drive',
    icon: 'fi fi-rr-cloud-upload',
    iconSvg: 'drive',
    url: '/drive',
    resource: 'documents',
  },
  {
    title: 'Schematic',
    key: 'schematic',
    icon: 'fi fi-rs-table-list',
    iconSvg: 'schematic',
    url: '/schematic',
    resource: 'schematic',
  },
  {
    category: true,
    title: 'Organization',
  },
  {
    title: 'Employees',
    icon: 'fi fi-rr-user-add',
    iconSvg: 'employees',
    key: 'toolsAllEmployees',
    url: '/tools/employees/all',
    resource: 'employees',
  },
  {
    title: 'Maintenance',
    icon: 'fi fi-rr-wrench-simple',
    iconSvg: 'maintenance',
    key: 'maintenance',
    url: '/tools/maintenance',
    resource: 'vehicles',
  },
  {
    title: 'Vehicles',
    key: 'vehicles',
    icon: 'fi fi-rr-bus',
    iconSvg: 'vehicles',
    url: '/tools/vehicles/all',
    resource: 'vehicles',
  },
  {
    category: true,
    title: 'Schools',
  },
  {
    title: 'Contracts',
    key: 'contracts',
    iconSvg: 'contracts',
    url: '/tools/contracts/all',
    resource: 'contracts',
  },
  {
    title: 'Districts',
    key: 'districts',
    iconSvg: 'districts',
    url: '/tools/districts/all',
    resource: 'districts',
  },
  {
    title: 'Buildings',
    key: 'toolsAllBuildings',
    iconSvg: 'buildings',
    url: '/tools/buildings/all',
    resource: 'buildings',
  },
  {
    title: 'Students',
    key: 'students',
    iconSvg: 'students',
    url: '/tools/students/all',
    resource: 'students',
  },
  {
    category: true,
    title: 'Maps',
  },
  {
    title: 'Routing',
    key: 'routes',
    iconSvg: 'routing',
    url: '/tools/routes/all',
    resource: 'routings',
  },
  {
    title: 'Telematics',
    key: 'telematics',
    iconSvg: 'telematics',
    url: '/tools/telematics/all',
    resource: 'telematics',
  },
]

export const getSettingMenuData = [
  {
    title: 'Dashboard',
    key: 'gotoDashboard',
    url: '/',
    icon: 'fe fe-arrow-left',
  },
  {
    category: true,
    title: 'Account',
  },
  {
    title: 'Profile',
    key: 'profile',
    iconSvg: 'profile',
    url: '/preferences/profile',
    disabled: true,
  },
  {
    title: 'Settings',
    key: 'settings',
    iconSvg: 'settings',
    url: '/preferences/settings',
    disabled: true,
  },
  {
    title: 'Security',
    key: 'security',
    iconSvg: 'security',
    url: '/preferences/security',
  },
  // ── ACCESS
  {
    category: true,
    title: 'Access',
  },
  {
    title: 'Departments',
    key: 'accessDepartments',
    iconSvg: 'departments',
    url: '/preferences/access/departments',
    resource: 'departments',
  },
  {
    title: 'Team',
    key: 'accessTeam',
    iconSvg: 'team',
    url: '/preferences/access/team',
    resource: 'team',
  },
  {
    title: 'Parents',
    key: 'accessParents',
    iconSvg: 'parents',
    url: '/preferences/access/parents',
    resource: 'parents',
  },
  {
    title: 'Partners',
    key: 'accessPartners',
    iconSvg: 'partners',
    url: '/preferences/access/partners',
    resource: 'partners',
  },
  {
    title: 'Roles',
    key: 'accessRoles',
    iconSvg: 'roles',
    url: '/preferences/access/roles',
    resource: 'permission_overrides',
  },
  {
    category: true,
    title: 'Organization',
  },
  {
    title: 'Devices',
    key: 'devices',
    iconSvg: 'devices',
    url: '/preferences/devices',
    resource: 'devices',
  },
  {
    title: 'Facilities',
    key: 'facilities',
    iconSvg: 'facilities',
    url: '/preferences/facilities',
    resource: 'facilities',
  },
  {
    title: 'Vendors',
    key: 'vendors',
    iconSvg: 'vendors',
    url: '/preferences/vendors',
    resource: 'settings',
  },
  // ── API
  {
    category: true,
    title: 'API',
  },
  {
    title: 'Tokens',
    key: 'apiTokens',
    iconSvg: 'tokens',
    url: '/preferences/api/tokens',
    disabled: true,
    resource: 'settings',
  },
  {
    title: 'Webhooks',
    key: 'apiWebhooks',
    iconSvg: 'webhooks',
    url: '/preferences/api/webhooks',
    disabled: true,
    resource: 'settings',
  },
]
